/**
 * TypeScript port by Ikaros Kappler.
 *
 * Original file from https://github.com/AlloyTeam/AlloyFinger
 *
 * @date 2021-02-10
 */
import { AlloyFinger } from './alloy_finger';
export { AlloyFinger };
export default AlloyFinger;
//# sourceMappingURL=index.js.map